<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_titulo}}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>
<!--Body-->
<div class="modal-body">
  <mdb-card>
        <mdb-card-body>
          <div *ngIf="esmasivo==false" class="form-row mb-3">
            <div class="col-3">Nombres:</div>
            <div class="col-9">
              <input mdbInput type="text" maxlength="100"  class="form-control" [(ngModel)]="x_informacion" placeholder="" readonly>
            </div>
           </div>
           <div *ngIf="esmasivo" class="form-row mb-3">
            <div class="col-12">
              <input mdbInput type="text" maxlength="100"  class="form-control" [(ngModel)]="x_informacion" placeholder="" readonly>
            </div>
           </div>
            <div class="form-row mb-3">
              <div class="col-3">Plantilla word:</div>
              <div class="col-9">

                <div *ngIf="seactualiza" class="custom-file">
                  <input type="file" class="custom-file-input" multiple id="importFileDoc" (change)="onFileDocChange($event.target.files)">
                  <label class="custom-file-label" #labelArchivoDoc for="importFileDoc">Seleccionar archivo</label>
              </div>
              <div *ngIf="esmasivo==false" class="input-group-append">
                <button *ngIf="seactualiza==false && esmasivo==false" mdbBtn type="button" (click)="onDescargarArchivo()" size="sm" class="btn btn-blue btn-rounded " mdbWavesEffect>
                  <mdb-icon fas icon="download" class="mr-1"></mdb-icon>Descargar</button>
                <button *ngIf="seactualiza==false" mdbBtn type="button" (click)="onMostrarActualizar(true)" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="sync" class="mr-1"></mdb-icon>Actualizar</button>
                <button *ngIf="seactualiza" mdbBtn type="button" (click)="onActualizarPlantilla()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="save" class="mr-1"></mdb-icon>Guardar</button>
                <button *ngIf="seactualiza" mdbBtn type="button" (click)="onMostrarActualizar(false)" size="sm" class="px-3 btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="window-close" class="mr-1"></mdb-icon>Cancelar</button>
              </div>
              <div *ngIf="esmasivo" class="input-group-append">
                <button mdbBtn type="button" (click)="onGenerarJuntado()" size="sm" class="btn btn-blue btn-rounded " mdbWavesEffect>
                  <mdb-icon fas icon="sync" class="mr-1"></mdb-icon>Juntar plantillas generadas</button>
              </div>

              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col-3">Archivo PDF:</div>
              <div class="col-9">

                <div class="custom-file">
                  <input type="file" class="custom-file-input" multiple id="importFilePdf" (change)="onFilePdfChange($event.target.files)">
                  <label class="custom-file-label" #labelArchivoPdf for="importFilePdf">Seleccionar archivo</label>
                </div>
              </div>
            </div>
          </mdb-card-body>
    </mdb-card>
    <br>
    <div class="justify-content-center" style="text-align: center;">
      <button  mdbBtn type="button" (click)="onEnviarFirma()"  size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
        <mdb-icon fas icon="share-square" class="mr-1"></mdb-icon>Enviar a firma</button>
    </div>

</div>
